import morphdom from "morphdom"
import { buildOptions } from "web-ui/morphdom/build-options"

export function morph(fromElement, toElement, customOptions = {}) {
  const updatedElements = []

  const options = buildOptions({
    ...customOptions,
    onElUpdated: (element) => updatedElements.push(element)
  })

  try {
    return morphdom(fromElement, toElement, options)
  } finally {
    for (const element of updatedElements) {
      element.dispatchEvent(new CustomEvent("morphdom:updated", { bubbles: false }))
    }
  }
}
